/**
 * إنشاء حساب الشريك/المقيم — POST /api/userPartner/signup/challenge
 */

import axios from "axios";
import { API_BASE_URL } from "../../../config";
import { setAuthToken } from "../../../services/authService";
import type { DonationLoginResponse } from "../../../services/authService";

const getBaseURL = () => {
  if (process.env.NODE_ENV === "development") return "";
  return API_BASE_URL;
};

const http = axios.create({
  baseURL: getBaseURL(),
  headers: { "Content-Type": "application/json", Accept: "application/json" },
  timeout: 60000,
});

export type RegistrationSignUpUser = {
  
  name: string;
  nationalId: string;
  login: string;
  password: string;
  countryName: string;
  email: string;
  phone: string;
  dob: string;
  userLang: string;
};

export type RegistrationSignUpRequest = {
  user: RegistrationSignUpUser;
  otpCode: string;
  challengeId: string; // New OTP challenge ID from /api/auth/signup/initiate-otp
  continueToken: string;
  nafathTransId?: string;
  nafathRequestId?: string;
};

export async function signUpUserPartner(
  request: RegistrationSignUpRequest
): Promise<DonationLoginResponse> {
  try {
    const { data } = await http.post<DonationLoginResponse>(
      "/api/userPartner/signup/challenge",
      request
    );
    if (!data || typeof data.token !== "string")
      throw new Error("Unexpected signup response");
    setAuthToken(data.token);
    if (data.user) {
      localStorage.setItem("authUser", JSON.stringify(data.user));
    }

    return data;
  } catch (err: unknown) {
    const res = err && typeof err === "object" && "response" in err
      ? (err as { response?: { data?: unknown; status?: number } }).response
      : null;
    const body = res?.data;
    const status = res?.status;
    const message =
      (body && typeof body === "object" && "message" in body
        ? (body as any).message
        : null) ||
      (body && typeof body === "object" && "detail" in body
        ? (body as any).detail
        : null) ||
      (typeof err === "object" && err !== null && "message" in err
        ? (err as any).message
        : null) ||
      "فشل إنشاء الحساب.";
    const e = new Error(message) as Error & { status?: number };
    e.status = status;
    throw e;
  }
}
